import { EventFilterKey } from '@/types/filters';

export const filtersColorMap: Record<EventFilterKey, string> = {
    city: 'bg-sky-600',
    event_type: 'bg-violet-600',
    language: 'bg-lime-600',
    price: 'bg-pink-600',
};
